import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import './GeneralDialog.styles.scss';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const dialogContentSx = { overflowY: 'auto' };
const dialogTitleSx = { m: 0, p: 2 };
const closeIconSx = (theme) => ({
  position: 'absolute',
  right: theme.tokens.spacing[8],
  top: theme.tokens.spacing[8],
  color: theme.palette.grey[500],
});
const footerButtonSx = { textTransform: 'none', margin: 1 };

const GeneralDialog = ({
  openDialog,
  setOpenDialog,
  dialogHeader,
  dialogBody,
  showDialogFooter,
  dialogFooterActionTextLeft,
  dialogFooterActionTextRight,
  leftButtonClick,
}) => {
  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openDialog}
        className={'oa-general-dialog'}
      >
        <DialogTitle sx={dialogTitleSx} id="customized-dialog-title" className="general-dialog-title">
          {dialogHeader ?? 'Modal title'}
        </DialogTitle>
        <IconButton aria-label="close" onClick={handleClose} sx={closeIconSx}>
          <CloseIcon />
        </IconButton>
        <DialogContent sx={dialogContentSx}>
          {dialogBody}
        </DialogContent>

        {showDialogFooter && (
          <>
            <Divider />
            <DialogActions>
              {dialogFooterActionTextLeft && (
                <Button autoFocus onClick={leftButtonClick} sx={footerButtonSx} variant="contained">
                  {dialogFooterActionTextLeft ?? 'Save changes'}
                </Button>
              )}
              {dialogFooterActionTextRight && (
                <Button autoFocus onClick={handleClose} sx={footerButtonSx} variant="outlined">
                  {dialogFooterActionTextRight ?? 'Cancel'}
                </Button>
              )}
            </DialogActions>
          </>
        )}
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default GeneralDialog;
